export const vars = {
  appName: 'AI-go Studio',
  asideWidth: '18.05rem',
}
